module.exports = __webpack_public_path__ + "be338e9a3d81136f4452e2c0fa50d90a.png";